import Timeline from "./Timeline";
import TaskIcon from "../../Assets/Icons/outline/task-square-black.svg";
import DesignIcon from "../../Assets/Images/design-district.png";
import ActionPage from "./ActionPage";

function FullPage({
  currentMonth,
  dataProject,
  line,
  handleShow,
  setCurrentMonth,
  setShowMonth,
  showMonth,
  monthArray,
  fullPage,
  setFullPage,
  selectedMember,
  setSelectedMember,
}) {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between m-5">
        <div className="flex items-center mb-5">
          <img src={TaskIcon} className="w-[40px] h-[40px] me-5" alt="" />
          <div className="text-[28px] pt-1 font-semibold capitalize">
            Project Task
          </div>
        </div>
        <div>
          <img src={DesignIcon} alt="" className="h-[40px]" />
        </div>

        <ActionPage
          setCurrentMonth={setCurrentMonth}
          setShowMonth={setShowMonth}
          showMonth={showMonth}
          currentMonth={currentMonth}
          monthArray={monthArray}
          fullPage={fullPage}
          setFullPage={setFullPage}
          selectedMember={selectedMember}
          setSelectedMember={setSelectedMember}
        />
      </div>
      <Timeline
        currentMonth={currentMonth}
        dataProject={dataProject}
        line={line}
        handleShow={handleShow}
        fullPage
      />
    </div>
  );
}

export default FullPage;
